import { FormGroup } from '@angular/forms';
import { UXControllerInit } from '../asd-uxControllerInit';
import { RowItem, HeaderItem } from '../asd-ie-type/asd-list';
import { MenuItem } from '../asd-ie-type/asd-menuItem';
import { TabItem } from '../asd-ie-type/asd-tabItem';
import { Attribute } from '../asd-attribute';
import { InterfaceElementCustomization } from './asd-interfaceElementCustomization';

export class InterfaceElement {
  InterfaceElementGroup: FormGroup;
  UXControllerInit: UXControllerInit;
  UXControllerStates: IEUXControllerStates;

  InterfaceElements: InterfaceElement[];
  MenuItems: MenuItem[];
  OriginalRowItems: RowItem[];
  UserActions: IEUserAction[];
  Filters: IEFilter[];
  Tabs: TabItem[];
  Messages: any[];

  Name: string;
  InterfaceElementID: string = null;
  TypeDID: string = null;
  TemplateID: string = null;
  ObjectID: string;
  ObjectName: string;
  ActionName: string;
  ImageIcon: string;
  CosyDataTypeID: string;
  CosyDataType: string;
  ViewAreaID: string;

  CSSProperty: any;

  DisplayOrder: number;
  LogicCount: number;
  ActionId: number;

  FilterAsHeader: boolean;
  isChecked : boolean;
  isFromRibbon: boolean;

  Attributes: Attribute;
  CustomizeOptions: InterfaceElementCustomization;

  PreLabel: IELabel;
  Label: IELabel;
  PostLabel: IELabel;
  PreLabelHigh: IELabel;
  PostLabelHigh: IELabel;

  DisplayProperties: IEDisplayProperties;

  Values: IEValue[];
  DynamicMetaData: IEDynamicItem;
  EntityList: IEEntityList;
  PayLoad: InterfaceElement;

 // FormControlProperties : IEFormControlProperties;
}


/*export class IEFormControlProperties{
  Disabled: boolean;
}*/

export class IEDisplayProperties{
  DisplayName: any;
  DisplaySrcKey : any;
  IsDisplayOnUI: boolean;
}

export class IELabel {
  ID: string;
  TemplateID: string;
  Name: string;
  TextStatus: string;
  TextToolTip: string;
  TextLong: string;
  TextShort: string;
  DID: string;
  DisplayName: any;
  Icon: string;
}

export class IEValue {
  Value: any;
  DisplayName: string;
  nil: boolean;
  Checked: boolean;
  Marked: boolean;
  NodeID: any;
  NodeOrderNo: any;
  NodeNewParentID: any;
 
}

export class IEDynamicItem {
  ObjectID:string;
  Items: [
    {
      DisplayName: string;
      ID: string;
      Visible: boolean;
    }
  ];
}

export class IEUserAction {
  Name: string;
  ID: string;
  UserActionID: string;
  TypeDID: string;
  MoreUserAction: boolean;
  ActionProcessOnServer: boolean;
  TemplateID: string;
}

export class IEUXControllerStates {
  PageID: string;
  FormID: string;
}

export class IEFilter {
  Name: any;
  ColName: any;
  ColValue: any;
  ColOrder: any;
  Condition: any;
  RetrieveLimit: any;
  RetrieveCategory: any;
  ShowAsHeader: boolean;
  DisplayColNames: any[];
}

export class IEEntityList {
  RowItems: RowItem[];
  HeaderItems: HeaderItem[];
}

export class IEFilterProperties {
  FilterAsHeader: boolean;
  ShowFilterSpec: [
    {
      FilterName: string;
      ColNames: any[];
    }
  ];
}


